"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const CompareUtil_1 = tslib_1.__importDefault(require("../util/CompareUtil"));
class ValueChangeEvent {
    static fire(source, value) {
        source.fireEvent(new ValueChangeEvent(value));
    }
    static fireIfNotEqual(source, oldValue, newValue) {
        if (ValueChangeEvent.shouldFire(oldValue, newValue)) {
            ValueChangeEvent.fire(source, newValue);
        }
    }
    static getType() {
        return ValueChangeEvent.prototype.constructor.name;
    }
    static shouldFire(oldValue, newValue) {
        return !CompareUtil_1.default.deepEquals(oldValue, newValue);
    }
    constructor(value, shouldValidate = true) {
        this.value = value;
        this.validate = shouldValidate;
    }
    getValue() {
        return this.value;
    }
    shouldValidate() {
        return this.validate;
    }
    dispatch(handler) {
        handler(this);
    }
}
exports.default = ValueChangeEvent;
//# sourceMappingURL=ValueChangeEvent.js.map